import { Timestamp } from 'firebase/firestore'

export function convertTime(timestamp: Timestamp | Date) {
  if (timestamp instanceof Date) {
    return timestamp.toString()
  } else if (timestamp instanceof Timestamp) {
    return timestamp.toDate().toDateString()
  }
}
